// La direccion de la entrega es la elegida al planificar cuando el cliente tiene
// varias (effective_location del backend); locatable.location siempre trae la
// principal, y por eso el pin, la geocerca y la ruta caian en otra comuna.
export const deliveryLocation = (delivery) => delivery?.effective_location || delivery?.locatable?.location;

const toCoordinate = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

/**
 * A donde va fisicamente la entrega: el punto de dropoff si lo tiene, si no la direccion
 * del cliente. `key` identifica el lugar y es lo que decide si dos entregas son la misma
 * parada.
 */
export const getDeliveryDestination = (delivery) => {
    const hasDropoff = Boolean(delivery?.dropoff ?? delivery?.order?.dropoff);
    const dropoffPoint = delivery?.dropoff_point || delivery?.order?.dropoff_point;
    const dropoffLat = toCoordinate(dropoffPoint?.lat);
    const dropoffLng = toCoordinate(dropoffPoint?.lng);

    if (hasDropoff && dropoffLat !== null && dropoffLng !== null) {
        return {
            lat: dropoffLat,
            lng: dropoffLng,
            isDropoff: true,
            // Por coordenadas y no por el id del punto: el mismo local puede llegar con ids
            // distintos (el por defecto del courier, uno buscado a mano) y es la misma parada.
            key: `dropoff-${dropoffLat.toFixed(5)}-${dropoffLng.toFixed(5)}`,
        };
    }

    const location = deliveryLocation(delivery);
    const locLat = toCoordinate(location?.lat);
    const locLng = toCoordinate(location?.lng);
    if (locLat !== null && locLng !== null) {
        return {
            lat: locLat,
            lng: locLng,
            isDropoff: false,
            // La key va por Location y no por cliente: un cliente puede aparecer
            // dos veces en el viaje con dos direcciones distintas.
            key: location?.id ? `loc-${location.id}` : `loc-${locLat}-${locLng}`,
        };
    }

    return null;
};

/**
 * Numero de parada de cada entrega, en el orden del viaje: `{ [delivery.id]: numero }`.
 *
 * El contador avanza cuando cambia el lugar, no por entrega: las entregas seguidas que van
 * al mismo destino comparten numero. Asi varios pedidos de clientes distintos que se dejan
 * en el mismo punto de dropoff son una sola parada, igual que en el mapa. Una entrega sin
 * coordenadas cae al cliente para no quedar sin numero.
 */
export const stopNumbersByDeliveryId = (deliveries) => {
    const stops = {};
    let lastKey = null;
    let currStop = 0;

    (deliveries || []).forEach((d) => {
        const key = getDeliveryDestination(d)?.key || `customer-${d?.locatable?.id}`;
        if (lastKey !== key) {
            lastKey = key;
            currStop += 1;
        }
        stops[d.id] = currStop;
    });

    return stops;
};
